import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { api } from '../../api.js';
import { useI18n } from '../../i18n/index.jsx';
import { Alert } from '../../components/ui.jsx';

// /unsubscribe/:token — one click from a bulk email (CASL): excludes this
// contact from future "Envoi groupé" sends. No sign-in. One-to-one email
// from the company is never affected.
// member: a PME Trade Canada member, from a product invitation (/unsubscribe/m/:token).
// alerts: the daily buying-request digest only (/unsubscribe/r/:token, migration 042).
export default function UnsubscribePage({ member = false, alerts = false }) {
  const { token } = useParams();
  const { t, errorText } = useI18n();
  const [state, setState] = useState('loading'); // loading | done | error
  const [error, setError] = useState('');
  useEffect(() => {
    api(alerts ? `/unsub/alerts/${token}` : member ? `/unsub/member/${token}` : `/unsub/${token}`, { method: 'POST' }).then(() => setState('done')).catch((e) => { setError(errorText(e)); setState('error'); });
  }, [token, member, alerts, errorText]);
  return (
    <div className="docview">
      <h1>{t('ws.bulk.unsubTitle')}</h1>
      {state === 'loading' && <p className="muted">{t('common.loading')}</p>}
      {state === 'done' && <p className="callout callout-success" role="status">{t(alerts ? 'ws.bulk.unsubAlertsDone' : member ? 'invite.unsubDone' : 'ws.bulk.unsubDone')}</p>}
      {state === 'error' && <Alert>{error}</Alert>}
    </div>
  );
}
